//expedition dashboard
export const SET_DASHBOARD_LOADING = "SET_DASHBOARD_LOADING";

export const DASHBOARD_DATA_SUCCESS = "DASHBOARD_DATA_SUCCESS";
export const DASHBOARD_DATA_FAIL = "DASHBOARD_DATA_FAIL";
export const DASHBOARD_FILTER_SUCCESS = "DASHBOARD_FILTER_SUCCESS";
export const DASHBOARD_FILTER_FAIL = "DASHBOARD_FILTER_FAIL";
export const PHASE_CHANGE = "PHASE_CHANGE";
export const CHART_EXPAND = "CHART_EXPAND";
export const RING_FORWARD = "RING_FORWARD";
export const SENSOR_COLLASPE = "SENSOR_COLLASPE";
export const SLIDE_IN = "SLIDE_IN";
export const SELECTED_GRAPH = "SELECTED_GRAPH";

//explore
export const SET_EXPLORE_LOADING = "SET_EXPLORE_LOADING";

export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";
export const ORDER_EVENTS_SUCCESS = "ORDER_EVENTS_SUCCESS";
export const ORDER_EVENTS_FAIL = "ORDER_EVENTS_FAIL";
export const SHOW_INSERERS_POP = "SHOW_INSERERS_POP";
export const SELECTED_COMPONENT_TYPE = "SELECTED_COMPONENT_TYPE";
